import { render, staticRenderFns } from "./mytraining.vue?vue&type=template&id=053ec806&scoped=true"
import script from "./mytraining.vue?vue&type=script&lang=js"
export * from "./mytraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ec806",
  null
  
)

export default component.exports